import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserContext } from '../../context/UserContext';
import { Spinner } from '../spinner/Spinner';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import Swal from 'sweetalert2';
import { Footer } from '../nav&foot/Footer';
import styles from './Styles.module.css';

export function Login() {
    const [isRegistred, setIsRegistred] = useState(true);
    const [error, setError] = useState('');
    const { users, registerUser, loginUser, isLoading, setIsLoading } =
        useContext(UserContext);
    const navigate = useNavigate();

    const userLogin = async (username: string, password: string) => {
        try {
            const user = users.find((e) => e.username === username);
            if (!user) {
                setError(`${username} is not registred!`);
            } else {
                if (user.password !== password) {
                    setError('Wrong password!');
                } else {
                    setIsLoading(true);
                    loginUser(user);
                    Swal.fire('Nice!', 'You log in correctly!', 'success').then(
                        () => navigate('/')
                    );
                }
            }
        } catch (e) {
            setError(`Error: ${e}`);
        }
    };

    const userRegister = async (
        email: string,
        username: string,
        password: string
    ) => {
        try {
            const emailRegistred = users.find((e) => e.email === email);
            const userRegistred = users.find((e) => e.username === username);
            if (emailRegistred) {
                setError('Your email is already in the database, log in!');
            } else if (userRegistred) {
                setError('That username is already in use!');
            } else {
                setIsLoading(true);
                setIsRegistred(true);
                setError('');
                registerUser({ email, username, password, id: '1' });
                Swal.fire(
                    'Good job!',
                    'You have registered correctly!',
                    'success'
                ).then(() => navigate('/'));
            }
        } catch (e) {
            setError(`Error: ${e}`);
        }
    };

    const changingIsRegistred = () => {
        setIsRegistred((e) => !e);
    };

    useEffect(() => {
        setIsLoading(false);
    }, [setIsLoading]);

    const footer = {
        color: 'rgba(255, 255, 255, 0.35)',
        fontSize: '12px',
        marginTop: '16px',
    };

    if (isLoading) return <Spinner />;

    return (
        <div className={styles.page}>
            {isRegistred ? (
                <LoginForm
                    registredOrNot={changingIsRegistred}
                    userSubmition={(u, p) => userLogin(u, p)}
                    serverError={error}
                />
            ) : (
                <RegisterForm
                    registredOrNot={changingIsRegistred}
                    userSubmition={(e, u, p) => userRegister(e, u, p)}
                    serverError={error}
                />
            )}
            <Footer styles={footer} />
        </div>
    );
}
